import { status } from "../_constants/commonLhd";
import { faqsConstant } from "../_constants/faqDetails.contant";

let initialState = {};

export function faq(state = initialState, action) {
    switch (action.type) {
        case faqsConstant.GET_FAQS_REQUEST:
            return {
                ...state,
                faq_status: status.IN_PROGRESS,
                faq_data: null,
            };
        case faqsConstant.GET_FAQS_SUCCESS:
            return {
                ...state,
                faq_status: status.SUCCESS,
                faq_data: action.data,
            };
        case faqsConstant.GET_FAQS_FAILURE:
            return {
                ...state,
                faq_status: status.FAILURE,
                faq_data: action.data,
            };
        default:
            return state;
    }
}
